import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
export const todoSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://server-assign-todo.herokuapp.com',
  }),
  tagTypes: ['todos'],
  endpoints: (builder) => ({
    getTodos: builder.query({
      query: ({ completed }) => {
        return `/todos?_sort=id&_order=desc&completed_like=${completed || ''}`
      },
      providesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    getStatusByTodos: builder.query({
      query: ({ completed, colors } = {}) => {
        let queryString = ''
        colors?.length &&
          colors.map((item) => {
            const string = `&color_like&${item}`
            queryString = queryString + (item = string)
            return {}
          })
        return `/todos?_sort=id&_order=desc&completed_like=${completed}${queryString || ''}`
      },
      transformResponse: (response, _meta, arg) => {
        response =
          response?.length > 0 &&
          response?.filter((item) =>
            arg?.colors?.length ? arg?.colors?.includes(item?.color) : item,
          )
        return {
          todos: response,
          colors: arg?.colors || [],
        }
      },
      providesTags: ['statusByTodos'],
    }),
    getTotalTodos: builder.query({
      query: ({ completed } = {}) => {
        return `/todos?_sort=id&_order=desc&completed_like=${false}`
      },
      providesTags: ['totalTodos'],
    }),
    addTodo: builder.mutation({
      query: ({ todo }) => ({
        url: '/todos',
        method: 'post',
        body: todo,
      }),
      invalidatesTags: ['todos', 'totalTodos', 'statusByTodos'],
    }),
    changeTodosStatus: builder.mutation({
      query: ({ todo }) => ({
        url: `/todos/${todo?.id}`,
        method: 'put',
        body: todo,
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    changeTodosColor: builder.mutation({
      query: ({ todo }) => ({
        url: `/todos/${todo?.id}`,
        method: 'put',
        body: todo,
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    allTaskStatus: builder.mutation({
      query: ({ todo }) => ({
        url: `/todos/${todo?.id}`,
        method: 'put',
        body: todo,
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    clearCompleteStatus: builder.mutation({
      query: ({ todo }) => ({
        url: `/todos/${todo?.id}`,
        method: 'delete',
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    updateTodos: builder.mutation({
      query: ({ todo }) => ({
        url: `/todos/${todo?.id}`,
        method: 'put',
        body: todo,
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    deleteTaskTodo: builder.mutation({
      query: (todoId) => ({
        url: `/todos/${todoId}`,
        method: 'delete',
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
    renameTaskTodoTitle: builder.mutation({
      query: ({ todo }) => ({
        url: `/todos/${todo?.id}`,
        method: 'put',
        body: todo,
      }),
      invalidatesTags: ['todos', 'statusByTodos', 'totalTodos'],
    }),
  }),
})
export const {
  useGetTodosQuery,
  useAddTodoMutation,
  useChangeTodosColorMutation,
  useChangeTodosStatusMutation,
  useAllTaskStatusMutation,
  useDeleteTaskTodoMutation,
  useRenameTaskTodoTitleMutation,
  useGetStatusByTodosQuery,
  useGetTotalTodosQuery,
  useUpdateTodosMutation,
  useClearCompleteStatusMutation,
} = todoSlice
